import { PasswordInput } from 'components/Inputs/PasswordInput';
import { TextInput } from 'components/Inputs/TextInput';
import { FC } from 'react';

import { Box, FormHelperText, Grid, Typography } from '@mui/material';

import { AlreadyRegisteredLink } from './AlreadyRegisteredLink';
import { PasswordStrength } from 'components/PasswordStrength';
import { TermsForm } from './TermsForm';

export const PartnerRegistrationForm: FC = ({ children }) => {
  return (
    <Box
      sx={{ height: '100%' }}
      alignContent="center"
      alignItems="center"
      justifyContent="space-evenly"
      display="flex"
      flexDirection="column"
      flex={1}
      py={4}
    >
      <Grid container spacing={2} sx={{ px: { xl: 6, lg: 8, md: 4, sm: 4 } }}>
        <Grid item container xs={12} justifyContent="center">
          <Typography
            component="h1"
            variant="h5"
            sx={{ fontWeight: 400, fontSize: 24 }}
          >
            Crie sua conta
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TextInput name="email" id="email" label="E-mail" required />
          <FormHelperText sx={{ textAlign: 'end' }}>
            Enviaremos um e-mail de confirmação
          </FormHelperText>
        </Grid>

        <Grid item xs={12}>
          <PasswordInput
            required
            fullWidth
            id="password"
            name="password"
            label="Senha"
          />
        </Grid>

        <Grid item xs={12}>
          <PasswordInput
            required
            fullWidth
            id="password-confirmation"
            name="passwordConfirmation"
            label="Confirme sua senha"
          />
        </Grid>

        <PasswordStrength />
      </Grid>

      <Box sx={{ width: '100%', mt: 2, px: { xl: 6, lg: 8, md: 4, sm: 4 } }}>
        <TermsForm />

        {children}

        <Box minHeight={20}>
          <AlreadyRegisteredLink />
        </Box>
      </Box>
    </Box>
  );
};
